import { createSignalAction, createSimpleCreator } from "shared/reduxUtils"

const BASE = "TIMELINE"

export const fetchClientTimelineAction = createSignalAction(BASE, "FETCH_CLIENT_TIMELINE")

export const fetchedAllTimelineEventsAction = createSimpleCreator(BASE, "FETCHED_ALL_TIMELINE_EVENTS")
